angular.module('admin.directives')

.directive('cmaEntry', ['HelperService', 'HomeService', 'HomeActivity', 'PageNotificationService', function(helpers, HomeService, HomeActivity, PageNotificationService){
  return {
    controllerAs: 'cmaEntryCtrl',
    bindToController: {
      agent: '=',
      preferredRea: '=',
      requester: '=',
      onCancel: '&',
      homeId: '@',
      onSave: '&',
    },
    scope: {},
    restrict: 'AE',
    templateUrl: '/admin/templates/partials/cma/cma-entry.html',

    controller: function(){
      var ctrl = this;

      ctrl.save = function(){
        let cma = ctrl.parseForSave();
        ctrl.loading = true;

        HomeService.agentCMA(ctrl.homeId, cma)
          .then(() => {
            return ctrl.sendCMANotification();
          })
          .then(() => {
            ctrl.onSave();
            ctrl.loading = false;
          })
          .catch((e) => {
            PageNotificationService.error(e.message);
          });
      };

      // TODO: move to api
      ctrl.sendCMANotification = function(){
        if(!ctrl.shouldSendNotification())
          return Promise.resolve();

        return HomeActivity
          .trackHome({
            source: 'agent',
            event: 'cma-notify-client',
            userId: ctrl.requester.id,
            homeId: ctrl.homeId,
            agentId: ctrl.agent.id
          });
      };

      ctrl.shouldSendNotification = function(){
        if(ctrl.requester.digestHasBeenSent)
          return true;

        return false;
      };

      ctrl.parseForSave = function(){
        let cma = _.cloneDeep(ctrl.cma);

        cma.amount = helpers.getFloatFromString(cma.amount);
        cma.high = helpers.getFloatFromString(cma.high);
        cma.low = helpers.getFloatFromString(cma.low);
        cma.requesterId = ctrl.requester.id;
        cma.source = ctrl.cmaWasPreferredRea ? 'mls-rea' : 'agent';
        cma.sourceId = ctrl.cmaWasPreferredRea ? ctrl.preferredRea.id : ctrl.agent.id;
        cma.agentId = ctrl.agent.id;

        return cma;
      };

      ctrl.setup = function(){
        if(ctrl.preferredRea)
          ctrl.cmaWasPreferredRea = true;
      };

      ctrl.setup();
    },

    link: function($scope, el, attrs, ctrl){
      $scope.$watch('cmaEntryCtrl.preferredRea', ctrl.setup);
    }
  }

}]);
